import React from 'react'
import {auth} from '../firebase'
import { signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth'
const FilterContext = React.createContext()

export function useFilter() {
    return React.useContext(FilterContext)
}
export function FilterProvider({children}) {
    const [filter, setFilter] = React.useState()
    const [filterData, setFilterData] = React.useState(
    {
        filterDate: "",
        filterTime: "",
        filterInviteOnly: false
    })

    const value =  {
        filter,
        setFilter,
        filterData,
        setFilterData
    }
    return (
        <div>
            <FilterContext.Provider value={value}>
                {children}
            </FilterContext.Provider>
        </div>
    );
}